import React, { useState } from "react";
import { GITHUB } from "icons";
import { EvtIntegrationInputCard } from "components/project/integration/inputcard";
import CreateRepoDialog from "./input";

export default function GithubIntegration({ project_slug }) {
  const [showRepoDialog, setShowRepoDialog] = useState(false);

  return (
    <div>
      <EvtIntegrationInputCard
        title={"Github"}
        icon={GITHUB}
        type={"Repo"}
        onClick={() => setShowRepoDialog(true)}
      />
      <CreateRepoDialog
        open={showRepoDialog}
        onOpenChange={setShowRepoDialog}
        project={project_slug}
      />
    </div>
  );
}
